import { render, staticRenderFns } from "./Supplies_boms.vue?vue&type=template&id=2a08059d&scoped=true"
import script from "./Supplies_boms.vue?vue&type=script&lang=js"
export * from "./Supplies_boms.vue?vue&type=script&lang=js"
import style0 from "./Supplies_boms.vue?vue&type=style&index=0&id=2a08059d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08059d",
  null
  
)

export default component.exports